module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Anchor-left-298eda12e3dd3bf111323ac020e94b0e.svg";